import React from 'react';
import { LuBuilding2 } from 'react-icons/lu';

import { ImageWithFallbackIcon } from '@/components/ImageWithFallbackIcon';
import { tickerLogoUrl } from '@/components/ticker-logo-url';

interface TickerLogoProps {
    tickerSymbol?: string;
    companyName?: string;
    className?: string;
    fallbackIconClassName?: string;
}

export const TickerLogo = ({ tickerSymbol, companyName, className, fallbackIconClassName }: TickerLogoProps) => {
    return (
        <ImageWithFallbackIcon
            src={tickerLogoUrl(tickerSymbol)}
            fallbackIcon={LuBuilding2}
            alt={`${companyName || tickerSymbol || 'Unknown'} logo`}
            className={className}
            fallbackIconClassName={fallbackIconClassName}
        />
    );
};
